import * as d3 from 'd3'
export default {

  methods: {
    
    draw_Timeline(chtData, cht) {    

      // Setting Timeline
      this.timeline.axis = d3.scaleBand()
      .domain(chtData.map(d => d.CDATE))
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      this.gmx_BandScaleValues_Week(chtData) // ##### init_TimelineValue.js #####
      // Set Coordinates for Bar X
      chtData.forEach((d,i)=> {
        d.bxs = this.gmx_BarCoordinates(d.mx, [...this.chart.styles.filter(f=> f.type=='BAR').map(m => m.size)], this.chart.barGap)
      })
      
      let Format = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

      this.timeline.month.forEach(d => {
        let abbr = String(d.name || '')
        let idx  = Format.indexOf(abbr)

        if (this.timeline.styles.month.format === 'num' && idx >= 0) d.name = String(idx + 1)
      })

      let st = this.timeline.styles

      let Timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(${cht.x+.5}, ${cht.y + this.chart.y + this.chart.height})`)
      .style('font-family', 'roboto')

      if(Object.keys(this.table).length > 0 && this.table.apply == 'Y') {
        this.draw_Table(Timeline, chtData)
        return
      }


      // Week
      Timeline
      .append('line')
      .attr('x1', this.chart.width).attr('y1', 0)
      .attr('x2', this.chart.width).attr('y2', st.week.lineY)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      this.timeline.week.forEach(d=> {

        if (this.timeline.cutoff.visible == 'Y' && d.cDate == this.timeline.cutoff.date) {
          Timeline
          .append('rect')
          .attr('x', d.sx).attr('y', 1)
          .attr('width', d.ex - d.sx).attr('height', this.timeline.cutoff.height)
          .attr('fill', this.timeline.cutoff.color).style('opacity', .3)
        }

        Timeline
        .append('line')
        .attr('x1', d.sx).attr('y1', 0)
        .attr('x2', d.sx).attr('y2', st.week.lineY)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        if(st.week.visible == 'Y') {
          Timeline
          .append('text')
          .attr('x', d.mx).attr('y', st.week.textY + st.week.tSize*0.36)
          .attr('font-size', st.week.tSize).attr('fill', st.week.tColor)
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
      })

      // Month
      if(st.month.visible == 'Y') {
        Timeline
        .append('line')
        .attr('x1', this.chart.width).attr('y1', (this.timeline.type == 'month') ? 0 : st.week.lineY)
        .attr('x2', this.chart.width).attr('y2', st.month.lineY)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        this.timeline.month.forEach(d=> {
          Timeline
          .append('line')
          .attr('x1', d.sx).attr('y1', (this.timeline.type == 'month') ? 0 : st.week.lineY)
          .attr('x2', d.sx).attr('y2', st.month.lineY)
          .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

          Timeline
          .append('text')
          .attr('x', d.mx).attr('y', st.month.textY + st.month.tSize*0.36)
          .attr('font-size', st.month.tSize).attr('fill', st.month.tColor)
          .attr('text-anchor', 'middle')
          .text(d.name)
        })
      }

      // Year
      if(st.year.visible == 'Y') {
        this.timeline.year.forEach((d,i)=> {
          if(i > 0) {
            Timeline
            .append('line')
            .attr('x1', d.sx).attr('y1', st.month.lineY)
            .attr('x2', d.sx).attr('y2', st.year.lineY)
            .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
          }

          Timeline
          .append('text')
          .attr('x', d.mx).attr('y', st.year.textY + st.year.tSize*0.36)
          .attr('font-size', st.year.tSize).attr('fill', st.year.tColor)
          .attr('text-anchor', 'middle')
          .text(d.name)
        })
      }

    },


  }
}
